export interface PopoverRect {
    top: number;
    bottom: number;
    left: number;
}

export interface PopoverPlacementInput {
    anchor: PopoverRect;
    popover: { width: number; height: number };
    viewport: { width: number; height: number };
    gap?: number;
    gutter?: number;
}

export function overflowBelow({
    anchorBottom,
    popoverHeight,
    viewportHeight,
    gap = 8,
    gutter = 16,
}: {
    anchorBottom: number;
    popoverHeight: number;
    viewportHeight: number;
    gap?: number;
    gutter?: number;
}) {
    return Math.max(0, anchorBottom + gap + popoverHeight + gutter - viewportHeight);
}

export function placePopover({ anchor, popover, viewport, gap = 8, gutter = 16 }: PopoverPlacementInput) {
    const top = anchor.bottom + gap;
    const maxLeft = Math.max(gutter, viewport.width - gutter - popover.width);
    const left = Math.min(Math.max(anchor.left, gutter), maxLeft);
    return { top, left };
}
